import useAppMutation from 'hooks/useAppMutation';
import useAppUser from 'hooks/useAppUser';
import { ScreenAndProtectEnrollPayload } from 'models/ScreenAndProtect';
import IntegrationsAPI from 'services/IntegrationsAPI';
import { useTranslation, Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useNotify from 'hooks/useNotify';
import { useQueryClient } from '@tanstack/react-query';
import { SCREEN_AND_PROTECT_ENROLLMENT_BASE_QUERY_KEY } from './useFetchScreenAndProtectEnrollment';

const useEnrollScreenAndProtect = () => {
  const { agencyUid } = useAppUser();
  const { notifySuccess, notifyError } = useNotify();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutateAsync } = useAppMutation(
    (payload: Omit<ScreenAndProtectEnrollPayload, 'agencyUid'>) => {
      return IntegrationsAPI.post(
        '/api/internal/screen-and-protect/enrollment',
        {
          agencyUid,
          ...payload,
        },
      );
    },
    {
      onSuccess: (_, payload) => {
        queryClient.invalidateQueries({
          queryKey: [SCREEN_AND_PROTECT_ENROLLMENT_BASE_QUERY_KEY, agencyUid],
        });
        notifySuccess(
          <Trans
            i18nKey="pageScreenAndProtect.enrollment.enrollSuccess"
            values={{
              propertiesCount: payload.propertiesUids.length,
            }}
            components={{
              br: <br />,
            }}
          />,
        );
        navigate('/screen-and-protect/current');
      },
      onError: () => {
        notifyError(t('pageScreenAndProtect.enrollment.enrollError'));
      },
    },
  );

  return {
    enroll: mutateAsync,
  };
};

export default useEnrollScreenAndProtect;
